import { Subject, Observable } from "rxjs";
import { Record } from './record';
import { ObjectTypes } from "@common/enums/object-types";
import { ViewStateFilterStates, ViewStateFilterElevations } from '@common/enums/viewstate-filter-states';
import { ViewStateOptions } from "@common/data-models/navigation/viewstate-options";
import { ViewStateFilter } from "@common/data-models/navigation/viewstate-filter";
import { ViewStateSequence } from "@common/data-models/navigation/viewstate-sequence";
import { ViewStateDelay } from "@common/data-models/navigation/viewstate-delay";
import { MatDrawerMode } from "@angular/material/sidenav";

export class ViewStateRecord extends Record {

	protected PropertySubject: Subject<[string, any, any]>;
	public PropertyObservable: Observable<[string, any, any]>;

	constructor() {
		super();
		this.initialize();
		this.type = ObjectTypes.PSTVIEWSTATE;
	}

	public toJSON() {
		if (Record.nomWebServicesJson.platformConvertor.useFor["logon"]) {
			return Record.nomWebServicesJson.platformConvertor.toServiceViewStateRecord(this)
		} else {
			return Record.nomWebServicesJson.Convertor.toServiceViewStateRecord(this);
		}
	}

	public initialize() {
		this.PropertySubject = new Subject<[string, any, any]>();
		this.PropertyObservable = this.PropertySubject.asObservable();
	}

	public set(field: string, value: any) {
		if (value instanceof ViewStateOptions
			|| value instanceof ViewStateFilter
			|| value instanceof ViewStateSequence
			|| value instanceof ViewStateDelay) {
			value.OnChange = (v, p) => {
				if (this.PropertySubject) this.PropertySubject.next([field, v, p]);
			}
		}
		let prev = this.get(field);
		super.set(field, value);
		if (this.PropertySubject) this.PropertySubject.next([field, value, prev]);
	}

	public get viewStateType(): number { 
		let res = this.getAs<number>("PSTViewStateType");
		if (typeof res === "string") {
			res = parseInt(res);
		}
		return res;
	}
	public set viewStateType(value: number) { this.set("PSTViewStateType", value); }

	public get viewStateFilterState(): boolean {
		let state = this.getAs<number>("PSTViewStateFilterState", ViewStateFilterStates.Expanded);
		if (!state) state = ViewStateFilterStates.Expanded;
		if (state == ViewStateFilterStates.Expanded) return true;
		return false;
	}
	public set viewStateFilterState(value: boolean) {
		let innerVal = ViewStateFilterStates.Expanded;
		if(!value) innerVal = ViewStateFilterStates.Collapsed;
		this.set("PSTViewStateFilterState", innerVal);
	}
	
	public get viewStateFilterElevation(): ViewStateFilterElevations { return this.getAs<ViewStateFilterElevations>("PSTViewStateFilterElevation", 'side'); }
	public set viewStateFilterElevation(value: ViewStateFilterElevations) { this.set("PSTViewStateFilterElevation", value); }
}
